const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.930573,3.997017 H 6.3207529 c -2.1346326,0 -3.4876149,2.3026321 -2.4136807,4.164106 L 11.072221,20.58034 c 0.467568,0.810915 1.639314,0.810915 2.106884,0 L 20.345709,8.161123 C 21.418188,6.3026241 20.065204,3.997017 17.932029,3.997017 Z M 11.066391,16.855996 9.5059445,13.835949 5.7407385,7.1018212 C 5.4923517,6.6708023 5.7991466,6.1184742 6.3192956,6.1184742 H 11.064933 V 16.857452 Z m 7.441281,-9.7556321 -3.763749,6.7370421 -1.560447,3.01859 V 6.1170171 h 4.745639 c 0.52015,0 0.826945,0.5523281 0.578557,0.9833468 z",
    fill: "#ffffff",
    style: {
      strokeWidth: 0.607154
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/ton.e94a811378b5f391ae964f7f43333f1d.svg";
export { ForwardRef as ReactComponent };